import DesignEditorSecondaryControls from './DesignEditorSecondaryControls';

export default DesignEditorSecondaryControls;
